import { useGetHotelSale, useCreateHotelSale } from 'api-hooks/sale/hotel';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import HotelSaleForm from './components/form';
import { HotelSaleFormType } from './components/form-type';

export type HotelSaleViewParams = {
  id: string;
  defaultValues?: HotelSaleFormType;
};

export default function HotelSaleView(
  props: NavigationProps<NavigationRoutes.HotelSalesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetHotelSale({
    id,
  });

  const { mutateAsync, error: errorMutate } = useCreateHotelSale();

  const hotelSale = data?.data;

  const onResolve = useApprovalableEdit('hotel-sales');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <HotelSaleForm
            {...props}
            hotelSale={hotelSale}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
